/**
 * cm-swatch-flag.js
 *
 * Setzt <body class="cm-has-swatches">, sobald die eigene Variantenauswahl
 * auf der Seite ist. Erst dadurch greift die Regel in cm-custom.css, die den
 * nativen Variant-Picker ausblendet.
 *
 * Warum ueber eine Klasse und nicht direkt per CSS: der native Picker MUSS
 * im DOM bleiben (seine Radios steuern den Variantenwechsel). Faellt die
 * eigene Auswahl aus irgendeinem Grund weg, bleibt der native Picker so
 * automatisch sichtbar und das Produkt bleibt bestellbar.
 */

function cmFlagSwatches() {
  var hasSwatches = document.querySelector('.cm-variant-swatches-block .cm-ws') !== null;
  document.body.classList.toggle('cm-has-swatches', hasSwatches);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cmFlagSwatches, { once: true });
} else {
  cmFlagSwatches();
}

document.addEventListener('shopify:section:load', cmFlagSwatches);
document.addEventListener('shopify:block:select', cmFlagSwatches);
document.addEventListener('shopify:block:deselect', cmFlagSwatches);
